module.exports = __webpack_public_path__ + "img/step03_02_locate_elements.0403a29a.png";